var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9551 5.92306C19.4116 3.27704 15.5884 3.27703 14.0449 5.92306L3.50903 23.9845C1.9535 26.6511 3.87698 30 6.96415 30H28.0359C31.123 30 33.0465 26.6511 31.491 23.9845L20.9551 5.92306Z",
    stroke: "#D65149",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H17C16.4477 12 16 12.4477 16 13V19C16 19.5523 16.4477 20 17 20H18C18.5523 20 19 19.5523 19 19V13C19 12.4477 18.5523 12 18 12Z",
    fill: "#D65149"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1895 22H17C16.4477 22 16 22.4477 16 23V24.2579C16 24.8102 16.4477 25.2579 17 25.2579H18.1895C18.7418 25.2579 19.1895 24.8102 19.1895 24.2579V23C19.1895 22.4477 18.7418 22 18.1895 22Z",
    fill: "#D65149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.e734d1acd49ffe8dffa3e8ca8363345f.svg";
export { ForwardRef as ReactComponent };